import { lazyLoadComponent } from "utilities/LazyLoad.utility";

export const ReportListLazyLoaded = lazyLoadComponent(() => import("./ReportList/ReportListPage"));

export const WorkInProgressReportLazyLoaded = lazyLoadComponent(
    () => import("./WorkInProgressReport/WorkInProgressReport"),
);

export const ProfitabilityReportLazyLoaded = lazyLoadComponent(
    () => import("./ProfitabilityReport/ProfitabilityReport"),
);

export const InvoicingReportLazyLoaded = lazyLoadComponent(
    () => import("./InvoicingReport/InvoicingReport"),
);

export const BudgetedVsProjectedReportLazyLoaded = lazyLoadComponent(
    () => import("./BudgetedVsProjectedReport/BudgetedVsProjectedReport"),
);

export const HoursWorkedByJobReportLazyLoaded = lazyLoadComponent(
    () => import("./HoursWorkedByJobReport/HoursWorkedByJobReport"),
);

export const HoursWorkedByEmployeeReportLazyLoaded = lazyLoadComponent(
    () => import("./HoursWorkedByEmployeeReport/HoursWorkedByEmployeeReport"),
);

export const SchedulePercentCompleteByJobReportLazyLoaded = lazyLoadComponent(
    () => import("./SchedulePercentCompleteByJobReport/SchedulePercentCompleteByJobReport"),
);

export const LaborActualsVsBudgetedReportLazyLoaded = lazyLoadComponent(
    () => import("./LaborActualsVsBudgetedReport/LaborActualsVsBudgetedReport"),
);

export const CashflowReportLazyLoaded = lazyLoadComponent(
    () => import("./CashflowReport/CashflowReport"),
);

export const DailyLogCreationByJobReportLazyLoaded = lazyLoadComponent(
    () => import("./DailyLogCreationByJobReport/DailyLogCreationByJobReport"),
);

export const LeadActivitiesBySalespersonReportLazyLoaded = lazyLoadComponent(
    () => import("./LeadActivitiesBySalespersonReport/LeadActivitiesBySalespersonReport"),
);

export const LeadStatusBySourceReportLazyLoaded = lazyLoadComponent(
    () => import("./LeadStatusBySourceReport/LeadStatusBySourceReport"),
);

export const DailyLogsByUserReportLazyLoaded = lazyLoadComponent(
    () => import("./DailyLogsByUserReport/DailyLogsByUserReport"),
);

export const BaselineVsActualDurationReportLazyLoaded = lazyLoadComponent(
    () => import("./BaselineVsActualDurationReport/BaselineVsActualDurationReport"),
);

export const ChangeOrderProfitReportLazyLoaded = lazyLoadComponent(
    () => import("./ChangeOrderProfitReport/ChangeOrderProfitReport"),
);

export const LeadCountBySalespersonReportLazyLoaded = lazyLoadComponent(
    () => import("./LeadCountBySalespersonReport/LeadCountBySalespersonReport"),
);
